import { makeStyles } from "tss-react/mui";

import { Theme } from "@mui/material";

export const drawerOpenWidth = 240;
export const drawerCloseWidth = 70;

export const useStyles = makeStyles()((theme: Theme) => ({
    root: {
        display: "flex",
        maxHeight: "100vh",
        height: "100vh",
        overflowX: "hidden",
        backgroundColor: theme.palette.emteria.background.default,
    },
    content: {
        flexGrow: 1,
        minWidth: 0,
        minHeight: 0,
        width: "100%",
        position: "relative",
        zIndex: 1,
        display: "flex",
        flexDirection: "column",
        overflowY: "auto",
        backgroundColor: theme.palette.emteria.background.default,
    },
    main: {
        minHeight: "100vh",
        minWidth: 0,
        flexGrow: 1,
    },
    drawer: {
        width: drawerOpenWidth,
        flexShrink: 0,
        whiteSpace: "nowrap",
        zIndex: 10,
        backgroundColor:
            theme.palette.mode === "light" ? theme.palette.emteria.background.default : theme.palette.emteria.background.paper,
    },
    drawerOpen: {
        overflow: "hidden",
        width: drawerOpenWidth,
        transition: theme.transitions.create("width", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
        backgroundColor:
            theme.palette.mode === "light" ? theme.palette.emteria.background.default : theme.palette.emteria.background.paper,
    },
    drawerClose: {
        overflow: "hidden",
        transition: theme.transitions.create("width", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        width: drawerCloseWidth,
        backgroundColor:
            theme.palette.mode === "light" ? theme.palette.emteria.background.default : theme.palette.emteria.background.paper,
    },
    logoBox: {
        padding: theme.spacing(4),
        display: "flex",
        alignItems: "center",
        cursor: "pointer",
        position: "relative",
        backgroundColor:
            theme.palette.mode === "light" ? theme.palette.emteria.background.default : theme.palette.emteria.background.paper,
    },
    envLabel: {
        position: "absolute",
        textTransform: "uppercase",
        color: theme.palette.emteria.error,
        bottom: theme.spacing(1),
        right: theme.spacing(1),
        fontSize: 14,
        fontWeight: 700,
        zIndex: 2,
    },
    mobileRoot: {
        display: "flex",
        flexDirection: "column",
        maxHeight: "100vh",
        height: "100vh",
        overflow: "hidden",
        backgroundColor: theme.palette.emteria.background.default,
    },
    mobileDrawerPaper: {
        width: "100%",
        maxWidth: "100%",
        backgroundColor:
            theme.palette.mode === "light" ? theme.palette.emteria.background.default : theme.palette.emteria.background.paper,
    },
    mobileMenuHeader: {
        position: "relative",
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(2),
        padding: theme.spacing(2, 3),
        backgroundColor:
            theme.palette.mode === "light" ? theme.palette.emteria.background.default : theme.palette.emteria.background.paper,
    },
    mobileEnvLabel: {
        marginLeft: "auto",
        textTransform: "uppercase",
        color: theme.palette.emteria.error,
        fontSize: 14,
        fontWeight: 700,
    },
    mobileMenuHeaderContainer: {
        position: "sticky",
        top: 0,
        zIndex: 10,
        flexShrink: 0,
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(2),
        padding: theme.spacing(2, 3),
        backgroundColor:
            theme.palette.mode === "light" ? theme.palette.emteria.background.default : theme.palette.emteria.background.paper,
    },
}));
